module.exports = __webpack_public_path__ + "static/media/button-arrow.b7780b23.svg";